import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { initSentryClient } from "./lib/sentry.browser";
import { initPostHog } from "./lib/posthog";

if (typeof window !== "undefined") {
  // Core error reporting stays eager (cheap, and we want early errors).
  initSentryClient();
  // Analytics is not part of the critical path — start it when the main thread
  // is free so it cannot add to Total Blocking Time during hydration.
  const idle = (
    window as unknown as {
      requestIdleCallback?: (cb: () => void, o?: { timeout: number }) => void;
    }
  ).requestIdleCallback;
  if (idle) idle(() => initPostHog(), { timeout: 6000 });
  else window.setTimeout(() => initPostHog(), 2500);
}

export const getRouter = () => {
  const queryClient = new QueryClient();

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
  });

  return router;
};
